import * as z from 'zod';

export const AddressSchema = z.object({
  /**
   * The first line of the address.
   */
  addressLine1: z.string().optional(),

  /**
   * The second line of the address.
   */
  addressLine2: z.string().optional(),

  /**
   * The city.
   */
  city: z.string().optional(),

  /**
   * The state or province.
   */
  state: z.string().optional(),

  /**
   * The postal code.
   */
  postalCode: z.string().optional(),

  /**
   * The country.
   */
  country: z.string().optional(),
});

export type Address = z.infer<typeof AddressSchema>;
